import i18next from 'i18next'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { StartTrialButton } from '../../../../../utils/buttons'
import { blockInviewHandler } from '../../../../../utils/inview'
import { homeInViewThreshold } from '../loggedOutHomeWidget'

export const HomeCTABlockLayout = () => (
  <InView
    as="section"
    threshold={homeInViewThreshold}
    triggerOnce={true}
    onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
    className="block block--home-cta"
  >
    <div className="block__inner container--m gutter--m">
      <div className="block__shape">
        <div className="block__content">
          <header className="block__header">
            <h2 className="block__title title--m">
              {i18next.t('home:ctaTitle')}
            </h2>
          </header>
          <div className="block__text">
            <p>{i18next.t('home:ctaIntro')}</p>
          </div>
          <footer className="block__footer">
            <StartTrialButton />
          </footer>
        </div>
      </div>
    </div>
  </InView>
)
